<script>
	import Badge from "../../components/tailwind/Badge.svelte";

	export let color = null;
	export let text = null;
</script>

<Badge backgroundColor={color} textColor={text}><slot /></Badge>
